export const vehiclespagetext = {
    registration: "Immatriculation",
    key: "Clé/code",
    name: "Nom",
    brand: "Marque",
    model: "Modèle",
    motor: "Motorisation",
    description: "Description",
    groups: "Groupe",
    dateend: "Date de sortie de la flotte",
    datebegin:"Date d'entrée dans la flotte",
    status:"Statut",
    comments:"Commentaires",
    graphdatebegin: "Date de début",
    graphdateend: "Date de fin",
    tablenodata: "Aucun véhicule à afficher",
    km : "Kilométrage",
    cost: "Coût (€)",
    co2: "Emission kgEqCo2",
    time: "Temps d'utilisation (h)",
    costkm: "Coût au kilomètre (c€/km)",
}